import React, { Component } from "react";
import {
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
  InputGroupButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import { LARGE_DEVICE_MIN_WIDTH } from "../util.js";

// UniversityId -> color css class
const COLOR_CLASSNAMES = {
  1: "red",
  2: "green",
  3: "black",
  4: "yellow"
};

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false
    };
    this.toggleDropDown = this.toggleDropDown.bind(this);
  }
  toggleDropDown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  renderDropdownItems() {
    const {
      query,
      inSearchPage,
      data: { universities }
    } = this.props;

    const items = [];
    for (const id in universities) {
      items.push(
        <DropdownItem
          key={id}
          onClick={() => this.props.onSelectUniversity(id, query, inSearchPage)}
        >
          {universities[id]}
        </DropdownItem>
      );
    }
    return items;
  }

  render() {
    const {
      universityId,
      query,
      inSearchPage,
      data: { universities }
    } = this.props;

    return (
      <InputGroup id="SearchBar" size="lg">
        <InputGroupButtonDropdown
          addonType="prepend"
          isOpen={this.state.dropdownOpen}
          toggle={this.toggleDropDown}
        >
          <DropdownToggle caret className={COLOR_CLASSNAMES[universityId]}>
            {universities[universityId]}
          </DropdownToggle>
          <DropdownMenu>{this.renderDropdownItems()}</DropdownMenu>
        </InputGroupButtonDropdown>
        <Input
          autoFocus={window.innerWidth > LARGE_DEVICE_MIN_WIDTH}
          placeholder="Busca profesor"
          value={query}
          onChange={event => {
            this.props.onQueryChange(
              universityId,
              event.target.value,
              inSearchPage
            );
          }}
        />
        <InputGroupAddon addonType="append">
          <Button
            onClick={() =>
              this.props.onSubmitSearch(universityId, query, inSearchPage)
            }
          >
            <i className="fa fa-search" aria-hidden="true" />
          </Button>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar.js